/*
本文の Markdown で、Python の特別な名前 (__name__、__init__ など) を太字に読ませない。
MarkdownContent が描く前に必ず通す (クラウドエディターの板、学習パスの項目の頁、レッスンの要件で同じ描き方にするため)。
レッスンの「満たすこと」の文は字のままで、`type(paid).__name__` のように囲まれていないことがある。
囲みの外の __x__ のうち、点の後ろ (type(x).__name__) か、Python の特別な名前の表にある物だけを \_\_x\_\_ にする。
__大事__ のような下線の太字は残す。コードの囲み (``` と ~~~ とバッククォート) の中は触らない
*/
const PYTHON_DUNDERS = new Set([
  "name", "main", "init", "new", "del", "str", "repr", "len", "eq", "ne", "lt", "le", "gt", "ge", "hash", "bool",
  "dict", "class", "doc", "file", "module", "all", "slots", "call", "iter", "next", "enter", "exit", "contains",
  "getitem", "setitem", "delitem", "getattr", "setattr", "add", "sub", "mul", "post_init", "builtins",
]);
const DUNDER = /(^|[^\w`\\])__([a-z][a-z0-9_]*?)__(?![\w])/g;
// コードの囲みに加え、図 (svg)、HTML のコードの要素 (pre、code、kbd、samp) とタグの中も触らない (id や属性の値、書いた字の下線を読み替えない)
const CODE = /(```[\s\S]*?```|~~~[\s\S]*?~~~|``[^`\n]+``|`[^`\n]*`|<svg[\s\S]*?<\/svg>|<pre\b[\s\S]*?<\/pre>|<code\b[\s\S]*?<\/code>|<kbd\b[\s\S]*?<\/kbd>|<samp\b[\s\S]*?<\/samp>|<\/?[A-Za-z][^>\n]*>)/;

export function escapeDunders(markdown: string): string {
  return markdown
    .split(CODE)
    .map((part, index) =>
      index % 2 === 1
        ? part
        : part.replace(DUNDER, (all, before: string, name: string) =>
            before === "." || PYTHON_DUNDERS.has(name) ? `${before}\\_\\_${name}\\_\\_` : all,
          ),
    )
    .join("");
}
